<template>
  <div>
    <!-- Modal de Lançamento -->
    <div
      class="modal fade"
      id="lancModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="lancamento">
          <div class="modal-header">
            <h5 class="modal-title">Criar Lançamento/Baixa</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-info py-2" v-if="lote_total > 0">
              <strong>Lançamentos: {{ lote_total }}</strong>
            </div>
             <div class="row">
                <div class="col col-12 col-md-12">
                  <az-input
                    label="Unidade"
                    type="select"
                    placeholder="Todas"
                    :optionsList="$store.state.unidade.unidade_operacaos"
                    optionsData="id_unidade_operacao"
                    required
                    :validate="validate"
                    :edicao="conciliacaoData && conciliacaoData.conta && conciliacaoData.conta.id_unidade_operacao == null"
                    v-model="lancamento.id_unidade_operacao" />
                </div>
            </div>
            <div class="row">
                <div class="col col-12 col-md-12" v-if="lista_centros.length > 1">
                    <az-input
                        sizing="sm"
                        label="Centro de Custo"
                        type="select"
                        placeholder="Selecione..."
                        :optionsList="lista_centros"
                        optionsData="id_centro_custo"
                        :validate="validate"
                        v-model="lancamento.id_centro_custo">
                    </az-input>
                </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-12">
                <selecao-categoria
                  v-model="lancamento.id_categoria"
                  :validate="validate"
                  :ch_tipo_lancamento="lancamento.ch_tipo_lancamento" />

                <az-input
                  v-if="false"
                  label="Categoria"
                  :validate="validate"
                  required
                  type="select"
                  optionsMode="aql"
                  service="categorias.index"
                  :optionsName="'categorias.' + ( lancamento ? lancamento.ch_tipo_lancamento : 'X' )"
                  optionsData="id_categoria"
                  optionsDisplay="search"
                  :optionsParm="{ lancamento: true, where: { ch_natureza: lancamento ? lancamento.ch_tipo_lancamento : '?' } }"
                  v-model="lancamento.id_categoria"
                />
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input
                    v-if="ofx_item_atual && ofx_item_atual.tipo == 'D'"
                    label="Fornecedor"
                    :validate="validate"
                    type="autocomplete"
                    optionsMode="aql"
                    service="fornecedores.index"
                    optionsData="id_fornecedor"
                    optionsDisplay="search"
                    v-model="lancamento.id_fornecedor_debito" />
                <az-input
                    v-else-if="ofx_item_atual && ofx_item_atual.tipo == 'C'"
                    label="Cliente"
                    type="select" 
                    optionsMode="aql"
                    optionsData="id_operadora"
                    optionsDisplay="st_operadora"
                    :optionsParms="{ fatura: true }"
                    service="operadoras.index"
                    optionsName="operadoras-para-fatura"
                    placeholder="Não informado."
                    v-model="lancamento.id_operadora">
                </az-input>
              </div>
            </div>

            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input
                  label="Forma de Pagamento"
                  :validate="validate"
                  required
                  type="select"
                  optionsMode="aql"
                  service="forma_pagamentos.index"
                  optionsData="id_forma_pagamento"
                  optionsDisplay="search"
                  v-model="lancamento.id_forma_pagamento"
                />
              </div>
            </div>
            <div class="row">
              <div class="col col-12 col-md-12">
                <az-input
                  label="Descrição"
                  :validate="validate"
                  required
                  v-model="lancamento.st_descricao"
                />
              </div>
            </div>
            <div class="row" v-if="conciliacaoItemSelecionado">
              <div class="col col-12 col-md-6">
                <div>Tipo</div>
                <div
                  class="lead"
                  :class="(conciliacaoItemSelecionado.TRNTYPE == 'DEP' || conciliacaoItemSelecionado.TRNTYPE == 'CREDIT' || conciliacaoItemSelecionado.TRNTYPE == 'XFER') ? 'text-primary' : 'text-danger'"
                >
                  <strong>{{transacao_selecionada_tipo}}</strong>
                </div>
              </div>
              <div class="col col-12 col-md-6">
                <div>Conta</div>
                <div class="lead">
                  <strong>{{conciliacaoData.conta.st_conta}}</strong>
                </div>
              </div>
            </div>
            <div class="row" v-if="conciliacaoItemSelecionado">
              <div class="col col-12 col-md-12">
                <div>Conta</div>
                <div
                  class="lead"
                  :class="(conciliacaoItemSelecionado.TRNTYPE == 'DEP' || conciliacaoItemSelecionado.TRNTYPE == 'CREDIT' || conciliacaoItemSelecionado.TRNTYPE == 'XFER') ? 'text-primary' : 'text-danger'"
                >
                  <strong>{{$util.formatMoeda(conciliacaoItemSelecionado.TRNAMT)}}</strong>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
            <az-submit v-if="!lote_em_execucao" @click="salvarLancamento ()">Salvar</az-submit>
            <button v-else type="button" class="btn btn-primary" disabled>
              Processando...
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Filtro -->
    <div class="card dashcard mb-0">
      <div class="card-body">
        <div class="row">
          <div class="col col-12 col-md-4">
            <az-input
              placeholder="Selecione uma conta"
              icon="fas fa-money-check-alt"
              type="select"
              optionsMode="aql"
              service="contas.index"
              optionsData="id_conta"
              optionsDisplay="search"
              :optionsParm="{ ativas: true }"
              v-model="filtro.id_conta"
              required
              :validate="validate"
            />
          </div>

          <div class="col col-12 col-md-4 d-flex flex-column">
            <az-submit color="outline-primary" @click="upload()">Carregar Arquivo</az-submit>
          </div>
        </div>
      </div>
    </div>

    <div class="progress mt-1 mb-3">
      <div class="indeterminate" v-if="$store.state.loading && conciliacaoData"></div>
      <div class="determinate" v-else></div>
    </div>

    <template v-if="conciliacaoData">
      <div class="card-deck">
        <!-- Extrato -->
        <div class="card carde" style="padding: 0px; height: 60vh;">
          <div class="card-body overflow-auto">
            <h5 class="card-title">Informações do Extrato bancário</h5>
            <fieldset :disabled="!!conciliacaoItemSelecionado">
            <div class="row">
              <div class="col col-12">
                <az-input
                  sizing="sm"
                  icon="fa fa-search"
                  placeholder="Pesquisar..."
                  v-model="extrato_search" />
              </div>
            </div>
            </fieldset>
            <table class="table table-responsive-md table-hover bg-light table-sm" v-if="conciliacaoData && conciliacaoData.transacoes">
              <thead>
                <tr>
                  <th v-if="extrato_search"></th>
                  <th>Data</th>
                  <th>Descrição</th>
                  <th class="text-right">Valor</th>
                  <th class="text-center">Conciliar</th>
                </tr>
              </thead>
              <tbody>
                <!-- Extrato -->
                <tr
                  v-for="transacao in transacoes_filtradas"
                  :key="getExtratoItemKey(transacao)"
                  :class="isExtratoItemSelecionado(transacao) ? 'bg-secondary text-light' : 'table-light'"
                >
                    <td v-if="extrato_search">
                      <input
                        v-if="!transacao.conciliado"
                        type="checkbox"
                        :checked="extrato_checks[getExtratoItemKey(transacao)]"
                        :disabled="tipo_lote_selecionado !== null && tipo_lote_selecionado !== transacao.tipo"
                        :title="tipo_lote_selecionado !== null && tipo_lote_selecionado !== transacao.tipo ? 'Só é possível selecionar itens do mesmo tipo (' + (tipo_lote_selecionado == 'D' ? 'Débito' : 'Crédito') + ')' : ''"
                        @change="toggleExtratoCheck(transacao)" />
                    </td>
                    <td>{{ $util.getFormatDate(transacao.DTPOSTED) }}</td>
                    <td>{{ transacao.MEMO }}</td>
                    <td
                      class="text-right"
                      class2="(transacao.TRNTYPE == 'DEP' || transacao.TRNTYPE == 'CREDIT' || transacao.TRNTYPE == 'XFER') ? 'text-primary' : 'text-danger'"
                      :class="transacao.tipo == 'D' ? 'text-danger' : 'text-primary'"
                    >{{ $util.formatMoeda(transacao.TRNAMT) }}</td>
                    <td class="text-nowrap text-center">
                      <a href="#" @click.prevent="copy_to_console(transacao)" v-if="false">
                        <i class="fas fa-copy"></i>
                      </a>
                      <template v-if="!transacao.conciliado">
                        <a
                          href="#"
                          @click.prevent="conciliarItem(transacao)"
                          v-if="transacoes_lote_selecionadas.length == 0 && (!conciliacaoItemSelecionado || isExtratoItemSelecionado(transacao))"
                        >
                          <i class="fas fa-pen"></i>
                        </a>
                        <i class="fas fa-pen" v-else></i>
                      </template>
                      <template v-else>
                        <a
                          href="#"
                          @click.prevent="conciliarItem(transacao)"
                          v-if="transacoes_lote_selecionadas.length == 0 && (!conciliacaoItemSelecionado || isExtratoItemSelecionado(transacao))"
                        >
                          <i class="fas fa-check-circle text-success"></i>
                        </a>
                        <i class="fas fa-check-circle" v-else></i>
                      </template>
                    </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer d-flex justify-content-end" v-if="transacoes_lote_selecionadas.length > 0">
            <button type="button" class="btn btn-sm btn-success" @click.prevent="criar_lancamentos_em_lote()">
              Criar Lançamentos
              <span class="badge badge-light ml-1">{{ transacoes_lote_selecionadas.length }}</span>
            </button>
            <button type="button" class="btn btn-sm btn-danger ml-2" @click.prevent="cancelar_lote()">
              Cancelar seleção
            </button>
          </div>
        </div>
        <!--Conciliar Baixas -->
        <div class="card carde"  style="padding: 0px; height: 60vh;" v-if="conciliacaoItemSelecionado">
          <div class="card-body overflow-auto">
            <h5 class="card-title">
              <strong>{{conciliacaoItemSelecionado.MEMO}}</strong>
            </h5>
            <div class="row">
              <div class="col col-12">
                <az-input
                  sizing="sm"
                  icon="fa fa-search"
                  placeholder="Pesquisar..."
                  v-model="conc_search" />
              </div>
            </div>

            <table class="table table-hover table-responsive-md bg-white table-sm" v-if="baixas_selecionadas">
              <thead>
                <tr>
                  <table-th title="" v-model="ordem" sortby="check" v-if="!conciliacaoItemSelecionado.conciliado"></table-th>
                  <table-th title="Id" v-model="ordem" sortby="id_lancamento"></table-th>
                  <table-th title="Data" v-model="ordem" sortby="dt_baixa"></table-th>
                  <table-th title="Descrição" v-model="ordem" sortby="st_descricao"></table-th>
                  <table-th title="Valor" v-model="ordem" sortby="valor_liquido" class="text-right"></table-th>
                </tr>
              </thead>
              <tbody class="small">
                <tr v-for="(item, idx) in baixas_selecionadas_filtradas" :key="idx" :class="item.nao_baixado ? 'table-warning' : ''">
                  <td v-if="!conciliacaoItemSelecionado.conciliado">
                    <input
                      type="checkbox"
                      v-model="item.check"
                      :disabled="transacoes_lote_selecionadas.length > 0" />
                  </td>
                  <td>
                    <a href="#" @click.prevent="abrir_lancamento(item.lancamento.id_lancamento)" class="text-primary" title="Clique para abrir o lançamento">
                      #{{ item.lancamento.id_lancamento }}
                    </a>
                  </td>
                  <td>{{ $util.getFormatDate(item.dt_baixa) }}</td>
                  <td>
                    {{ item.lancamento.st_descricao }}
                    <span class="badge badge-warning ml-2" v-if="item.nao_baixado">Não baixado</span>
                  </td>
                  <td
                    class="text-right"
                    :class="(item.tipo_lancamento_conciliacao || item.tipo_lancamento) == 'D' ? 'text-danger' : 'text-primary'"
                  >{{ $util.formatMoeda (item.valor_liquido) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer d-flex justify-content-between">
            <div class="small">
              <div>
                Extrato: {{ $util.formatMoeda(conciliacaoItemSelecionado.TRNAMT) }}
              </div>
              <div v-if="!conciliacaoItemSelecionado.conciliado">
                Conciliado: {{ $util.formatMoeda(total_baixas_selecionadas) }}
                <i class="fas fa-check-circle text-success ml-1" v-if="conciliacao_item_ok"></i>
              </div>
            </div>
            <div>
              <template v-if="conciliacaoItemSelecionado.conciliado">
                <button type="button" class="btn btn-sm btn-danger" @click.prevent="cancelarItemSelecionado()">
                  Cancelar
                </button>
                <button type="button" class="btn btn-sm btn-danger ml-2" @click.prevent="removerItemSelecionado()">
                  Remover conciliação
                </button>
              </template>
              <template v-else>
                <button type="button" class="btn btn-sm btn-info mr-2" @click.prevent="criar_transferencia()">
                  Criar Transferência
                </button>
                <button type="button" class="btn btn-sm btn-success mr-2" @click.prevent="criarLancamento()">
                  Criar Lançamento
                </button>
                <button type="button" class="btn btn-sm btn-danger" @click.prevent="cancelarItemSelecionado()">
                  Cancelar
                </button>
                <button type="button" class="btn btn-sm btn-primary ml-2" :disabled="!conciliacao_item_ok" @click.prevent="confirmarConciliacaoItem()">
                  Conciliar
                </button>
              </template>
            </div>
          </div>
        </div>
        <!-- Resumo do extrato -->
        <div class="card carde" v-else>
          <div class="card-body">
            <h5 class="card-title">Informações do arquivo</h5>

            <div class="row mb-2">
              <div class="col col-12 col-md-6">
                <div>Conta</div>
                <div class="lead text-primary">
                  <strong>{{conciliacaoData.conta.st_conta}}</strong>
                </div>
              </div>
              <div class="col col-12 col-md-6">
                <div>Período do extrato</div>
                <div class="lead text-primary">
                  <strong>{{resumo_periodo}}</strong>
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col col-12 col-md-6">
                <div>Qtde. itens no extrato</div>
                <div class="lead text-primary">
                  <strong>{{conciliacaoData.transacoes.length}}</strong>
                </div>
              </div>
              <div class="col col-12 col-md-6">
                <div>Qtde. baixas não concliadas</div>
                <div class="lead text-primary">
                  <strong>{{conciliacaoData.baixas.length}}</strong>
                </div>
              </div>
            </div>

            <div class="row mb-2">
              <div class="col col-12 col-md-6">
                <div>Total créditos no extrato</div>
                <div class="lead text-success">
                  <strong>{{$util.formatMoeda(resumo_total_creditos)}}</strong>
                </div>
              </div>
              <div class="col col-12 col-md-6">
                <div>Total débitos no extrato</div>
                <div class="lead text-danger">
                  <strong>{{$util.formatMoeda(resumo_total_debitos)}}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <az-empty-state />
    </template>
    
    <edicao-lancamento ref="edicaoLancamento" :viewonly="edicaoLancViewOnly" @refresh="on_lancamento_refresh" />
  </div>
</template>

<script>
// import * as moment from "moment";
import _ from "lodash";
import $ from "jquery";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from "../../util/AzSubmit.vue";
import AzEmptyState from "../../util/AzEmptyState.vue";
import SelecaoCategoria from './SelecaoCategoria.vue';
import TableTh from '../../shared/table/TableTh.vue';
import EdicaoLancamento from './EdicaoLancamento.vue';

export default {
  data() {
    return {
      conciliacaoData: null,
      conciliacaoItemSelecionado: null,
      lancamento: null,
      validate: false,
      teste: "",
      ordem: "",
      filtro: {
        id_conta: "",
      },
      conc_search: "",
      extrato_search: "",
      edicaoLancViewOnly: true,
      itemPendenteConciliacao: null,
      ofxContent: null,
      extrato_checks: {},
      lote_pendente: [],
      lote_item_atual: null,
      lote_total: 0,
      lote_processados: 0,
      lote_em_execucao: false,
      lote_dados_base: null,
    };
  },
  components: {
    AzInput,
    AzEmptyState,
    AzSubmit,
    SelecaoCategoria,
    TableTh,
    EdicaoLancamento
  },

  methods: {
    normalizeConciliacaoData(data) {
      if (!data || !Array.isArray(data.transacoes)) return data;

      const sequencias = {};
      data.transacoes = data.transacoes.map((transacao, index) => {
        const checknum = Array.isArray(transacao.CHECKNUM)
          ? transacao.CHECKNUM[0]
          : transacao.CHECKNUM;
        const baseKey = [
          transacao.KEY || "",
          transacao.FITID || "",
          transacao.DTPOSTED || "",
          transacao.TRNAMT || "",
          transacao.MEMO || "",
          checknum || "",
          index,
        ].join("::");
        const sequencia = sequencias[baseKey] || 0;
        sequencias[baseKey] = sequencia + 1;

        return {
          ...transacao,
          _selection_key: `${baseKey}::${sequencia}`,
        };
      });

      return data;
    },

    getExtratoItemKey(transacao) {
      if (!transacao) return null;

      if (transacao._selection_key) return transacao._selection_key;

      const checknum = Array.isArray(transacao.CHECKNUM)
        ? transacao.CHECKNUM[0]
        : transacao.CHECKNUM;

      return [
        transacao.KEY || "",
        transacao.FITID || "",
        transacao.DTPOSTED || "",
        transacao.TRNAMT || "",
        transacao.MEMO || "",
        checknum || "",
      ].join("::");
    },

    isExtratoItemSelecionado(transacao) {
      return !!this.conciliacaoItemSelecionado
        && this.getExtratoItemKey(this.conciliacaoItemSelecionado) === this.getExtratoItemKey(transacao);
    },

    comparaValores(v1, v2) {
        let valor1, valor2;

        try {
            valor1 = Math.round(+v1* 100);
        } catch (_) {
            valor1 = v1;
        }

        try {
            valor2 = Math.round(+v2 * 100);
        } catch (_) {
            valor2 = v2;
        }

        return valor1 == valor2;
    },

    copy_to_console (item) {
      console.log(item);
    },

    abrir_lancamento(id_lancamento) {
      this.edicaoLancViewOnly = true;
      this.$refs.edicaoLancamento.editar({
        id_lancamento: id_lancamento
      });
    },

    on_lancamento_refresh() {
      if ( this._itemPendenteConciliacao ) {
        this._itemPendenteConciliacao = null;
        this.resetSelecionado();

        // Recarrega a conciliação para exibir a transferência criada nas baixas
        if ( this._ofxContent ) {
          this.$util.load(this, {
            service: "financeiro.conciliacao",
            func: "conciliacao",
            redir_api: true,
            parms: {
              json: this._ofxContent,
              id_conta: this.filtro.id_conta,
            },
            loadTo: (res) => {
              this.conciliacaoData = this.normalizeConciliacaoData(res);
              this.cancelar_lote();
            },
          });
        }
      }
    },

    criar_transferencia() {
      const item = this.conciliacaoItemSelecionado;
      const data = item ? this.$util.getFormatDate(item.DTPOSTED, 'YYYY-MM-DD') : this.$util.hoje();

      // Débito: dinheiro saiu da conta selecionada → ela é a origem
      // Crédito: dinheiro entrou na conta selecionada → ela é o destino
      const eh_debito = item && item.tipo == 'D';

      this._itemPendenteConciliacao = item;
      this.edicaoLancViewOnly = false;
      this.$refs.edicaoLancamento.incluir(true, this.filtro.id_conta, {
        id_conta_baixa: this.filtro.id_conta,
        id_conta_origem:  eh_debito ? this.filtro.id_conta : '',
        id_conta_destino: eh_debito ? '' : this.filtro.id_conta,
        dc_valor: item ? Math.abs(item.TRNAMT) : 0,
        st_descricao: item ? item.MEMO : null,
        dt_competencia: item ? this.$util.getFormatDate(item.DTPOSTED, 'YYYY-MM') : this.$util.hoje(),
        dt_emissao: data,
        dt_vencimento: data,
        // dados de conciliação para o backend criar já conciliado
        conciliado: true,
        data_conciliacao: item ? item.DTPOSTED : null,
        fitid: item ? item.FITID : null,
        checknum: item ? ( Array.isArray(item.CHECKNUM) ? item.CHECKNUM[0] : item.CHECKNUM ) : null,
        memo: item ? item.MEMO : null,
        key: item ? item.KEY : null,
      }, 'T');
    },

    upload() {
      this.validate = false;
      if(this.filtro && !this.filtro.id_conta) {
        this.validate = true;
        this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Seleciona a conta bancária",
            life: 3000,
          });
        return;
      }

      this.resetTelaNovoUpload();

      var downloadAnchorNode = document.createElement("input");
      downloadAnchorNode.setAttribute("type", "file");
      downloadAnchorNode.setAttribute("class", "d-none");
      downloadAnchorNode.onchange = () => {
        this.posUpload(downloadAnchorNode);
      };
      document.body.appendChild(downloadAnchorNode);
      downloadAnchorNode.click();
    },
    posUpload(el) {
      var file = el.files[0];
      if (file) {
        var reader = new FileReader();

        reader.readAsText(file, "ISO-8859-1");

        reader.onload = (evt) => {
            this._ofxContent = evt.target.result;
            this.$util
                .load(this, {
                    service: "financeiro.conciliacao",
                    func: "conciliacao",
                    redir_api: true,
                    parms: {
                        json: evt.target.result,
                        id_conta: this.filtro.id_conta,
                    },
                    loadTo: (res) => {
                        this.conciliacaoData = this.normalizeConciliacaoData(res);
                        this.cancelar_lote();
                    },
                });
            // .then((res) => {
            //   this.conciliacaoData = res;
            // })
            // .finally(() => {
            //   this.$store.commit('loading', false);
            // });
        };

        reader.onerror = function () {
          this.$toast.add({
            severity: "error",
            summary: "Atenção",
            detail: "Falha lendo arquivo.",
            life: 3000,
          });
        };
      }
    },
    conciliarItem(transacao) {
      if (this.isExtratoItemSelecionado(transacao)) {
        this.cancelarItemSelecionado();
        return;
      }

      this.conc_search = "";
      this.conciliacaoItemSelecionado = transacao;

      if (!this.conciliacaoItemSelecionado.conciliado)
      {
        let found = false;
        this.baixas_selecionadas.forEach((item) => {
          if (
            !found &&
            this.$util.getFormatDate(this.conciliacaoItemSelecionado.DTPOSTED) == this.$util.getFormatDate(item.dt_baixa) &&
            this.comparaValores(this.conciliacaoItemSelecionado.TRNAMT, item.valor_liquido)
          ) {
            item.check = true;
            found = true;
          } else {
            item.check = false;
          }
        });
      }
    },
    cancelarItemSelecionado() {
      if (!this.conciliacaoItemSelecionado.conciliado)
        this.baixas_selecionadas.forEach((item) => {
          item.check = false;
        });
      this.resetSelecionado();
    },
    removerItemSelecionado() {
      const key = this.conciliacaoItemSelecionado.KEY;

      this.$util.atualizar(this, {
        service: "financeiro",
        func: "remover_conciliar_baixa",
        dados: {
          baixas: this.baixas_selecionadas,
        },
        toast: true,
        callback: () => {
          this.baixas_selecionadas
            .filter((item) => item.conciliacao_key == key)
            .forEach((item) => {
              item.st_conciliacao_fitid = "";
              item.conciliacao_key = "";
            });
          this.conciliacaoItemSelecionado.conciliado = false;
          this.resetSelecionado();
        },
      });
    },
    confirmarConciliacaoItem() {
      const itensSelecionados = this.baixas_selecionadas.filter((item) => item.check);
      const baixasSelecionadas = itensSelecionados.filter((item) => !item.nao_baixado);
      const lancamentosNaoBaixadosSelecionados = itensSelecionados
        .filter((item) => item.nao_baixado)
        .map((item) => item.lancamento);

      if (!itensSelecionados.length) {
        return;
      }

      const finalizarSucesso = () => {
        this.$toast.add({
          severity: "success",
          summary: "Conciliação",
          detail: "Conciliação realizada com sucesso.",
          life: 3000,
        });

        this.conciliacaoItemSelecionado.conciliado = true;
        this.resetSelecionado();
      };

      const tratarErro = (res) => {
        this.$toast.add({
          severity: "error",
          summary: "Conciliação",
          detail: res ? res.original.msg : "Erro ao conciliar baixa.",
          life: 5000,
        });
      };

      const processarNaoBaixados = (onComplete) => {
        if (!lancamentosNaoBaixadosSelecionados.length) {
          onComplete();
          return;
        }

        this.salvarLancamentoNaoBaixado(
          lancamentosNaoBaixadosSelecionados,
          () => onComplete(),
          (res) => tratarErro(res)
        );
      };

      if (!baixasSelecionadas.length) {
        processarNaoBaixados(() => finalizarSucesso());
        return;
      }

      this.$util.atualizar(this, {
        service: "financeiro",
        func: "conciliar_baixa",
        dados: {
          baixas: baixasSelecionadas,
          fitid: this.conciliacaoItemSelecionado.FITID,
          data_conciliacao: this.conciliacaoItemSelecionado.DTPOSTED,
          memo: this.conciliacaoItemSelecionado.MEMO,
          checknum: Array.isArray(this.conciliacaoItemSelecionado.CHECKNUM)
            ? this.conciliacaoItemSelecionado.CHECKNUM[0]
            : this.conciliacaoItemSelecionado.CHECKNUM,
          key: this.conciliacaoItemSelecionado.KEY,
        },
        callback: (res) => {
          if (res && res.original.status_code >= 400) {
            tratarErro(res);
          } else {
            const fitid = this.conciliacaoItemSelecionado.FITID;
            const checkNum = Array.isArray(this.conciliacaoItemSelecionado.CHECKNUM)
                ? this.conciliacaoItemSelecionado.CHECKNUM[0]
                : this.conciliacaoItemSelecionado.CHECKNUM;
            const key = this.conciliacaoItemSelecionado.KEY;

            this.baixas_selecionadas
              .filter((item) => item.check)
              .filter((item) => !item.nao_baixado)
              .forEach((item) => {
                item.st_conciliacao_fitid = fitid;
                item.st_conciliacao_checknum = checkNum;
                item.conciliacao_key = key;
              });

            processarNaoBaixados(() => finalizarSucesso());
          }
        },
      });
    },

    salvarLancamentoNaoBaixado(lancamentos, onComplete, onError) {
      const fila = [...lancamentos];

      const processar = () => {
        if (!fila.length) {
          if (onComplete) onComplete();
          return;
        }

        const lancamento = fila.shift();
        const dados = {
          ...lancamento,
          id_lancamento: lancamento.id_lancamento,
          id_conta_baixa: this.conciliacaoData.conta.id_conta,
          conciliado: true,
          tipo_lanc: "R",
          conciliar_nao_baixado: true,
          data_conciliacao: this.conciliacaoItemSelecionado.DTPOSTED,
          fitid: this.conciliacaoItemSelecionado.FITID,
          checknum: Array.isArray(this.conciliacaoItemSelecionado.CHECKNUM)
            ? this.conciliacaoItemSelecionado.CHECKNUM[0]
            : this.conciliacaoItemSelecionado.CHECKNUM,
          memo: this.conciliacaoItemSelecionado.MEMO,
          key: this.conciliacaoItemSelecionado.KEY,
        };

        if (dados.dt_competencia) {
          dados.dt_competencia = ("" + dados.dt_competencia).substr(0, 7);
        }

        // Remove campos apenas de visualização/local para evitar payload inválido.
        delete dados.check;
        delete dados.nao_baixado;
        delete dados.tipo_lancamento_conciliacao;
        delete dados.valor_liquido;
        delete dados.dt_baixa;
        delete dados.lancamento;
        delete dados.conta_origem;
        delete dados.conta_destino;
        delete dados.categoria;
        delete dados.js_classes;
        delete dados.hash_id;
        delete dados.search;
        delete dados.vencimento;
        delete dados.carregando;
        delete dados.estado;
        delete dados.liquido;
        delete dados.valor_md;
        delete dados.baixado;
        delete dados.pode_adiantar;
        delete dados.valor_retencoes;
        delete dados.uso_credito;

        this.$util.atualizar(this, {
          service: "financeiro",
          func: "store",
          dados: dados,
          toast: false,
          callback: (res) => {
            if (res && res.original && res.original.status_code >= 400) {
              if (onError) onError(res);
              return;
            }

            const baixaCriada = res && res.data ? res.data : res;
            if (baixaCriada) {
              this.conciliacaoData.baixas.push(baixaCriada);
            }

            processar();
          },
        });
      };

      processar();
    },
    criarLancamento() {
      this.lancamento =  null;
      this.validate = false;

      this.$nextTick(() => {
        this.lancamento = {
            id_lancamento: null,
            id_categoria: null,
            id_forma_pagamento: null,
            dc_valor: this.conciliacaoItemSelecionado.TRNAMT,
            dt_competencia: this.$util.getFormatDate(
            this.conciliacaoItemSelecionado.DTPOSTED,
            "YYYY-MM"
            ),
            dt_emissao: this.$util.getFormatDate(
            this.conciliacaoItemSelecionado.DTPOSTED,
            "YYYY-MM-DD"
            ),
            dt_vencimento: this.$util.getFormatDate(
            this.conciliacaoItemSelecionado.DTPOSTED,
            "YYYY-MM-DD"
            ),
            st_descricao: this.conciliacaoItemSelecionado.MEMO
                ? this.conciliacaoItemSelecionado.MEMO
                : this.$util.getFormatDate(this.conciliacaoItemSelecionado.DTPOSTED, "YYYY-MM-DD"),
            ch_tipo_lancamento: this.conciliacaoItemSelecionado.tipo,
            ch_estado: "A",
            recorrente: false,
            //quantidade: 12,
            tipo_lanc: "R",
            id_conta_baixa: this.conciliacaoData.conta.id_conta,
            id_unidade_operacao: this.conciliacaoData.conta.id_unidade_operacao,
        };

        $("#lancModal").modal("show");
      });
    },

    validarLancamentoModal() {
      this.validate = true;

      return new Promise((resolve) => {
        this.$nextTick(() => {
          const invalids = $("#lancModal .invalid:visible");

          if (invalids.length) {
            this.$toast.add({
              severity: "error",
              summary: "Atenção",
              detail: "Verificar preenchimento dos campos.",
              life: 3000,
            });
            resolve(false);
            return;
          }

          resolve(true);
        });
      });
    },

    reativarLote(item, erro) {
      if (item) {
        const itemJaPendente = this.lote_pendente.some(
          (pendente) => this.getExtratoItemKey(pendente) === this.getExtratoItemKey(item)
        );

        if (!itemJaPendente) {
          this.lote_pendente.unshift(item);
        }
      }

      this.lote_item_atual = item || null;
      this.lote_em_execucao = false;

      this.$toast.add({
        severity: "error",
        summary: "Conciliação",
        detail: erro && erro.original && erro.original.msg
          ? erro.original.msg
          : "Não foi possível continuar o processamento do lote.",
        life: 5000,
      });
    },

    resetTelaNovoUpload() {
      this.conciliacaoData = null;
      this.conciliacaoItemSelecionado = null;
      this.lancamento = null;
      this.validate = false;
      this.conc_search = "";
      this.extrato_search = "";
      this.ordem = "";
      this.edicaoLancViewOnly = true;
      this.itemPendenteConciliacao = null;
      this.ofxContent = null;
      this._itemPendenteConciliacao = null;
      this._ofxContent = null;
      this.cancelar_lote();

      $("#lancModal").modal("hide");
    },

    async salvarLancamento() {
      const lancamentoValido = await this.validarLancamentoModal();
      if (!lancamentoValido) {
        this.lote_em_execucao = false;
        return;
      }

      const isLote = this.lote_total > 0 && this.lote_pendente.length > 0;

      if (isLote) {
        this.lote_dados_base = { ...this.lancamento };
        this.lote_dados_base.dt_competencia = this.lote_dados_base.dt_competencia.substr(0, 7);
        this.lote_em_execucao = true;
        this.processar_proximo_lote();
        return;
      }

      let dados = { ...this.lancamento };
      dados.dt_competencia = dados.dt_competencia.substr(0, 7);
      dados.conciliado = true;
      const ofxItem = this.conciliacaoItemSelecionado;
      dados.data_conciliacao = ofxItem.DTPOSTED;
      dados.fitid = ofxItem.FITID;
      dados.checknum = Array.isArray(ofxItem.CHECKNUM)
        ? ofxItem.CHECKNUM[0]
        : ofxItem.CHECKNUM;
      dados.memo = ofxItem.MEMO;
      dados.key = ofxItem.KEY;

      this.$util.atualizar(this, {
        service: "financeiro",
        func: "store",
        dados: dados,
        modal: "lancModal",
        no_validate: true,
        toast: true,
        callback: (res) => {
          this.conciliacaoData.baixas.push(res);
          this.conciliacaoItemSelecionado.conciliado = true;
          this.resetSelecionado();
        },
      });
    },
    resetSelecionado() {
      this.conciliacaoItemSelecionado = null;
    },

    toggleExtratoCheck(transacao) {
      const key = this.getExtratoItemKey(transacao);
      this.$set(this.extrato_checks, key, !this.extrato_checks[key]);
    },

    cancelar_lote() {
      this.extrato_checks = {};
      this.lote_pendente = [];
      this.lote_item_atual = null;
      this.lote_total = 0;
      this.lote_processados = 0;
      this.lote_em_execucao = false;
      this.lote_dados_base = null;
    },

    criar_lancamentos_em_lote() {
      this.lote_pendente = [...this.transacoes_lote_selecionadas];
      this.lote_total = this.lote_pendente.length;
      this.lote_processados = 0;
      this.lote_em_execucao = false;
      this.lote_dados_base = null;

      if (!this.lote_pendente.length) return;

      const item = this.lote_pendente[0];
      this.lote_item_atual = item;
      this.lancamento = null;
      this.validate = false;
      this.$nextTick(() => {
        this.lancamento = {
          id_lancamento: null,
          id_categoria: null,
          id_forma_pagamento: null,
          dc_valor: item.TRNAMT,
          dt_competencia: this.$util.getFormatDate(item.DTPOSTED, "YYYY-MM"),
          dt_emissao: this.$util.getFormatDate(item.DTPOSTED, "YYYY-MM-DD"),
          dt_vencimento: this.$util.getFormatDate(item.DTPOSTED, "YYYY-MM-DD"),
          st_descricao: item.MEMO || this.$util.getFormatDate(item.DTPOSTED, "YYYY-MM-DD"),
          ch_tipo_lancamento: item.tipo,
          ch_estado: "A",
          recorrente: false,
          tipo_lanc: "R",
          id_conta_baixa: this.conciliacaoData.conta.id_conta,
          id_unidade_operacao: this.conciliacaoData.conta.id_unidade_operacao,
        };
        $("#lancModal").modal("show");
      });
    },

    processar_proximo_lote() {
      if (!this.lote_pendente.length) {
        const total = this.lote_total;
        this.cancelar_lote();
        $("#lancModal").modal("hide");
        this.$toast.add({
          severity: "success",
          summary: "Conciliação",
          detail: total + " lançamento(s) criado(s) e conciliado(s) com sucesso.",
          life: 4000,
        });
        return;
      }

      const item = this.lote_pendente.shift();
      this.lote_item_atual = item;

      const dados = {
        ...this.lote_dados_base,
        conciliado: true,
        dc_valor: item.TRNAMT,
        dt_competencia: this.$util.getFormatDate(item.DTPOSTED, "YYYY-MM"),
        dt_emissao: this.$util.getFormatDate(item.DTPOSTED, "YYYY-MM-DD"),
        dt_vencimento: this.$util.getFormatDate(item.DTPOSTED, "YYYY-MM-DD"),
        st_descricao: item.MEMO || this.$util.getFormatDate(item.DTPOSTED, "YYYY-MM-DD"),
        ch_tipo_lancamento: item.tipo,
        data_conciliacao: item.DTPOSTED,
        fitid: item.FITID,
        checknum: Array.isArray(item.CHECKNUM) ? item.CHECKNUM[0] : item.CHECKNUM,
        memo: item.MEMO,
        key: item.KEY,
      };

      this.$util.atualizar(this, {
        service: "financeiro",
        func: "store",
        dados: dados,
        no_validate: true,
        toast: false,
        callback: (res) => {
          this.conciliacaoData.baixas.push(res);
          item.conciliado = true;
          this.$set(this.extrato_checks, this.getExtratoItemKey(item), false);
          this.lote_processados += 1;
          this.processar_proximo_lote();
        },
        callback_error: (res) => {
          this.reativarLote(item, res);
        },
        error: (res) => {
          this.reativarLote(item, res);
        },
      });
    },
  },
  computed: {
    lista_centros: function() {
      if (!this.conciliacaoData.conta.id_unidade_operacao) return [];

      let und = this.$store.state.unidade.unidade_operacaos.find(
          item =>
              item.id_unidade_operacao == this.conciliacaoData.conta.id_unidade_operacao
      );

      return und ? und.centro_custos : [];
    },

    base_baixas_selecionadas: function () {
      if (!this.conciliacaoItemSelecionado || !this.conciliacaoData || !this.conciliacaoData.baixas ) {
        return [];
      }

      return this.conciliacaoData.baixas.filter((item) => {
        let conciliado = this.conciliacaoItemSelecionado.conciliado
          ? item.conciliacao_key == this.conciliacaoItemSelecionado.KEY
          : ( item.tipo_lancamento == this.conciliacaoItemSelecionado.tipo && !item.st_conciliacao_fitid );

        if(conciliado == false && this.conciliacaoItemSelecionado.conciliado && this.conciliacaoItemSelecionado.conciliado_old) {
            conciliado = ( item.conciliacao_key == this.conciliacaoItemSelecionado.KEY_OLD );
        }

        return conciliado;
      });

    },

    base_lancamentos_nao_baixados_selecionados: function () {
      if (!this.conciliacaoItemSelecionado || !this.conciliacaoData || !this.conciliacaoData.lancamentos_nao_baixados) {
        return [];
      }

      if (this.conciliacaoItemSelecionado.conciliado) {
        return [];
      }

      const tipo = this.conciliacaoItemSelecionado.tipo;
      const dataExtrato = this.$util.getFormatDate(this.conciliacaoItemSelecionado.DTPOSTED, "YYYY-MM-DD");
      const valorExtrato = this.conciliacaoItemSelecionado.TRNAMT;

      return this.conciliacaoData.lancamentos_nao_baixados
        .filter((item) => {
          const valorLancamento = item.liquido != null ? item.liquido : item.dc_valor;
          const dataVencimento = item.dt_vencimento ? this.$util.getFormatDate(item.dt_vencimento, "YYYY-MM-DD") : null;
          const dataPagamento = item.dt_pagamento ? this.$util.getFormatDate(item.dt_pagamento, "YYYY-MM-DD") : null;

          const mesmoTipo = item.ch_tipo_lancamento == tipo;
          const mesmoValor = this.comparaValores(valorExtrato, valorLancamento);
          const mesmaData = dataExtrato == dataVencimento || dataExtrato == dataPagamento;

          return mesmoTipo && mesmoValor && mesmaData;
        })
        .map((item) => {
          if (typeof item.check === "undefined") this.$set(item, "check", false);
          if (typeof item.nao_baixado === "undefined") this.$set(item, "nao_baixado", true);
          else item.nao_baixado = true;

          if (!item.lancamento) this.$set(item, "lancamento", _.omit(item, ["lancamento"]));
          if (typeof item.valor_liquido === "undefined") {
            this.$set(item, "valor_liquido", item.liquido != null ? item.liquido : item.dc_valor);
          }
          if (typeof item.dt_baixa === "undefined") {
            this.$set(item, "dt_baixa", item.dt_pagamento || item.dt_vencimento || item.dt_emissao);
          }
          if (typeof item.tipo_lancamento_conciliacao === "undefined") {
            this.$set(item, "tipo_lancamento_conciliacao", item.ch_tipo_lancamento || tipo);
          }

          return item;
        });
    },

    baixas_selecionadas_filtradas: function () {
      const reg = this.$util.getregex(this.conc_search);
      return this.baixas_selecionadas.filter(item => !this.conc_search || reg.test(JSON.stringify(item)));
    },

    transacoes_filtradas: function () {
      if (!this.conciliacaoData || !this.conciliacaoData.transacoes) return [];
      if (!this.extrato_search) return this.conciliacaoData.transacoes;
      const reg = this.$util.getregex(this.extrato_search);
      return this.conciliacaoData.transacoes.filter(item => reg.test(JSON.stringify(item)));
    },

    transacoes_lote_selecionadas: function () {
      if (!this.conciliacaoData || !this.conciliacaoData.transacoes) return [];
      return this.conciliacaoData.transacoes.filter(
        t => !t.conciliado && this.extrato_checks[this.getExtratoItemKey(t)]
      );
    },

    tipo_lote_selecionado: function () {
      const sel = this.transacoes_lote_selecionadas;
      return sel.length > 0 ? sel[0].tipo : null;
    },

    ofx_item_atual: function () {
      return this.lote_item_atual || this.conciliacaoItemSelecionado;
    },

    baixas_selecionadas: function () {
      if (!this.conciliacaoItemSelecionado)
        return null;

      let baixas = [
        ...this.base_baixas_selecionadas,
        ...this.base_lancamentos_nao_baixados_selecionados,
      ];

      console.log('base_baixas_selecionadas', this.base_baixas_selecionadas);

      if ( this.ordem ) {
          baixas = _.sortBy(baixas, (item) => {
              return _.get(item, this.ordem.name );
          });

          if ( this.ordem.direction == 'desc' ) {
              baixas = _.reverse(baixas);
          }
      }
      
      console.log('baixas_selecionadas', baixas);

      return baixas;
    },

    total_baixas_selecionadas: function () {
      return !this.baixas_selecionadas
        ? 0
        : this.baixas_selecionadas.reduce((total, item) => {
            return total + (item.check ? item.valor_liquido : 0);
          }, 0);
    },

    conciliacao_item_ok: function () {
      let valor1, valor2;

      try {
        valor1 = Math.round(+this.conciliacaoItemSelecionado.TRNAMT * 100);
      } catch (_) {
        valor1 = this.conciliacaoItemSelecionado.TRNAMT;
      }

       try {
        valor2 = Math.round(+this.total_baixas_selecionadas * 100);
      } catch (_) {
        valor2 = this.total_baixas_selecionadas;
      }

      return (
        this.conciliacaoItemSelecionado &&
        this.baixas_selecionadas &&
            valor1 == valor2
      );
    },

    resumo_total_creditos: function () {
      if (!this.conciliacaoData) return 0;
      if (!this.conciliacaoData.transacoes) return 0;
      return this.conciliacaoData.transacoes.reduce((total, item) => {
        return total + (item.tipo == "C" ? item.TRNAMT : 0);
      }, 0);
    },

    resumo_total_debitos: function () {
      if (!this.conciliacaoData) return 0;
      if (!this.conciliacaoData.transacoes) return 0;
      return this.conciliacaoData.transacoes.reduce((total, item) => {
        return total + (item.tipo == "D" ? item.TRNAMT : 0);
      }, 0);
    },

    resumo_periodo: function () {
      if (!this.conciliacaoData) return "";
      if (!this.conciliacaoData.transacoes) return "";

      const inicio = _.first(this.conciliacaoData.transacoes);
      const fim = _.last(this.conciliacaoData.transacoes);
      return inicio && fim
        ? this.$util.getFormatDate(inicio.DTPOSTED) +
            " a " +
            this.$util.getFormatDate(fim.DTPOSTED)
        : "";
    },
    transacao_selecionada_tipo: function () {
      return this.conciliacaoItemSelecionado
        ? this.conciliacaoItemSelecionado.tipo == "C"
          ? "Crédito"
          : "Débito"
        : "";
    },

    total_selecionado_para_conciliar: function () {
      return this.base_baixas_selecionadas.filter(item => item.check)
        .reduce((total, carry) => {
          return total + parseFloat(carry.valor_liquido);
        }, 0);
    }
  },

  mounted() {
    this.$store.commit("setBreadcrumb", [
      { name: "Financeiro", path: "/financeiro" },
      { name: "Conciliação bancária", path: "/financeiro/conciliacao" },
    ]);
  },
};
</script>
